import { colors } from "@indeed/ifl-tokens";

import { Bookmark } from "../../../../../../mads";

export interface SaveJobButtonIconProps {
  isSaved: boolean;
}

export function SaveJobButtonIcon(props: SaveJobButtonIconProps): React.JSX.Element {
  const { isSaved } = props;
  return isSaved ? (
    <Bookmark variant="filled" color={colors.foreground.strong} />
  ) : (
    <Bookmark variant="stroke" color={colors.foreground.strong} />
  );
}
